import uniq from 'lodash/uniq'
import { useEffect } from 'react'
import { useSiteState } from 'siteState/shared'

export type UseBoundFilterQueryElementParams = {
  filterQueryTargetUuid?: string
}

export const useBoundFilterQueryElement = ({
  filterQueryTargetUuid
}: UseBoundFilterQueryElementParams): void => {
  const [, setBoundFilterQueryElements] = useSiteState<string[]>(
    'bound-filter-query-elements'
  )

  useEffect(() => {
    if (filterQueryTargetUuid) {
      setBoundFilterQueryElements((prevState) =>
        uniq([...(prevState ?? []), filterQueryTargetUuid])
      )
    }
  }, [filterQueryTargetUuid, setBoundFilterQueryElements])
}
